<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.39753 7.9375L2.66253 6.2025C2.46753 6.0075 2.15253 6.0075 1.95753 6.2025C1.76253 6.3975 1.76253 6.7125 1.95753 6.9075L4.04753 8.9975C4.24253 9.1925 4.55753 9.1925 4.75253 8.9975L10.0425 3.7075C10.2375 3.5125 10.2375 3.1975 10.0425 3.0025C9.84753 2.8075 9.53253 2.8075 9.33753 3.0025L4.39753 7.9375Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Valid'
  }
</script>
